<template>
  <div class="big-box">
    <div class="mainline">
      <span class="primary">
        {{ core.charisma || 0 }}
      </span>
    </div>
    <label class="has-toggle" @click="toggleState = !toggleState">
      <span>Charisma</span>
    </label>
    <toggle v-model="toggleState"></toggle>

    <div v-if="toggleState" class="text-center">
      <under-input v-model.number="core.charisma" type="number">Base</under-input>
    </div>

  </div>
</template>
<script>
import { mapState } from "vuex";
import Toggle from "../shared/_Toggle.vue";
import UnderInput from "../shared/_UnderInput.vue";

export default {
  name: "big-boxes-charisma",
  components: {
    Toggle,
    UnderInput
  },
  data() {
    return {
      toggleState: false
    };
  },
  computed: mapState({
    ruleset: state => state.characters.current.ruleset,
    core: state => state.characters.current.core
  })
};
</script>

<style lang="scss" scoped>
.has-toggle {
  padding-left: 1.25em;
}
</style>
